module.exports = __webpack_public_path__ + "static/media/skywallet_1.cd072146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skywallet/components/Gallery/skywallet_1.jpg
// module id = 1615
// module chunks = 0